import { useReducer, useEffect } from 'react';
import { useTheme } from 'styled-components';
import { getScreenSize } from '../layout.js';
import { useSkeletonStore } from './useSkeletonStore.js';

const useScreenContext = () => {
  const theme = useTheme();
  const skeletonStore = useSkeletonStore();
  const [screenSize, handleScreenSize] = useReducer(oldScreenSize => {
    const newScreenSize = getScreenSize(theme);
    if (newScreenSize !== oldScreenSize) {
      return newScreenSize;
    }
    return oldScreenSize;
  }, 'xxl');
  useEffect(() => {
    window.addEventListener('resize', handleScreenSize);
    handleScreenSize();
    return () => window.removeEventListener('resize', handleScreenSize);
  }, []);
  return {
    screenSize,
    skeletonStore
  };
};

export { useScreenContext };
//# sourceMappingURL=useScreenContext.js.map
